import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link, scroller } from "react-scroll";
import cx from "classnames";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { useViewport } from "@cinch-labs/shared-util";
import { SearchButton } from "../search-button";
import { reviewSectionsData } from "../review-sections/review-sections.data";
import styles from "./sticky-nav.module.css";
import sharedStyles from "../../car-reviews-v2.module.css";
const navRefs = reviewSectionsData.reduce((refs, item)=>{
    refs[item.id] = /*#__PURE__*/ React.createRef();
    return refs;
}, {});
const scrollIntoView = (element)=>{
    const navElement = element;
    const navContainer = document.querySelector(".stickyNavListScrollIntoView");
    if (navContainer) {
        const leftPosition = navElement.getBoundingClientRect().left + navContainer.scrollLeft;
        const containerCenter = navContainer.clientWidth / 2;
        const elementCenter = navElement.clientWidth / 2;
        // Calculate the scroll position for the center alignment
        const scrollPosition = leftPosition - containerCenter + elementCenter;
        // Smoothly scroll the container to the calculated position
        navContainer.scrollTo({
            left: scrollPosition,
            behavior: "smooth"
        });
    }
};
export const StickyNav = ({ make , model , windowBottomScrollPosition , areVehiclesInStock  })=>{
    const { trackEvent  } = useAnalytics();
    const handleClick = (title)=>{
        trackEvent({
            eventName: `Car Review - Review Navigation Menu - ${title}`,
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "review mega nav",
                    label: title,
                    action: make,
                    value: model
                }
            }
        });
    };
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isDesktop = vw >= 1024;
    const verdictSection = scroller.get("verdict");
    const verdictSectionTopPosition = verdictSection === null || verdictSection === void 0 // optional chain required so tests pass
     ? void 0 : verdictSection.offsetTop;
    const showStickyWindowCtaButton = !isDesktop && windowBottomScrollPosition <= verdictSectionTopPosition;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                className: styles.stickyNav,
                "aria-hidden": true,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: cx(styles.stickyNavInner, sharedStyles.inner),
                    children: [
                        /*#__PURE__*/ _jsx("ul", {
                            className: cx(styles.stickyNavList, "stickyNavListScrollIntoView"),
                            children: reviewSectionsData.map((item)=>/*#__PURE__*/ _jsx("li", {
                                    "aria-label": item.title,
                                    ref: navRefs[item.id],
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        className: styles.stickyNavLink,
                                        activeClass: styles.stickyNavLinkActive,
                                        to: item.id,
                                        spy: true,
                                        smooth: true,
                                        offset: -100,
                                        "data-text": item.title,
                                        onClick: ()=>handleClick(item.id),
                                        onSetActive: ()=>{
                                            const currentElement = navRefs[item.id].current;
                                            if (currentElement instanceof HTMLElement) {
                                                scrollIntoView(currentElement);
                                            }
                                        },
                                        children: item.title
                                    })
                                }, item.id))
                        }),
                        isDesktop && areVehiclesInStock && /*#__PURE__*/ _jsx(SearchButton, {
                            make: make,
                            model: model,
                            small: true,
                            onClick: ()=>handleClick("search for vehicle")
                        })
                    ]
                })
            }),
            showStickyWindowCtaButton && areVehiclesInStock && /*#__PURE__*/ _jsx("div", {
                className: styles.stickyNavCtaMobileContainer,
                children: /*#__PURE__*/ _jsx(SearchButton, {
                    make: make,
                    model: model,
                    onClick: ()=>handleClick("search for vehicle"),
                    small: true
                })
            })
        ]
    });
};
